import {AppFunction} from "../misc/types";
import {SessionsView} from "../views/sessions";
import View from "../framework/view";
import {InventoryView} from "../views/inventory";

export class InventoryFunction extends AppFunction {

    readonly v : View;

    constructor(admin: boolean) {
        super();
        this.v = new InventoryView();
    }

    view() {
        return this.v;
    }
    url() {
        return "/inventory";
    }

}

